export default __webpack_public_path__ + "static/media/ComponentLib.3bc434ea.PNG";